<template>
<v-flex fill fill-height horizontal>
    <div class="text-xs-center" v-if="loading">
        <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
        ></v-progress-circular>
    </div>
    <div v-else class="header-section">
        <v-layout>
            <v-flex xs7><h1>{{season.name}} Weeks</h1></v-flex>
            <v-flex xs5>
                <v-select
                    :items="seasons"
                    label="Standard"
                    v-model="season"
                    item-text="name"
                    :return-object="true"
                    solo
                ></v-select>
            </v-flex>
        </v-layout>
    </div>
    <section v-if="!loading" class="elevation-1">
        <div v-sticky="stickyConfig" style="background:white" class="table-header-section">
            <v-data-table ref="headerTable" :headers="headers" :items="[]" hide-actions disable-initial-sort dense></v-data-table>
        </div>

        <v-data-table
                :headers="headers"
                :items="weeks"
                hide-actions
                ref="dataTable"
                class="division-table"
                dense
        >
            <template slot="items" slot-scope="props">
                <tr @click="$router.push(getEditorLink(props.item))">
                    <td class="rollup-cell-sm">{{props.item.week === 0 ? 'Bye': props.item.week}}</td>
                    <td class="rollup-cell-md hidden-md-down">{{props.item.week_date | dateOnly}}</td>
                    <td class="rollup-cell-sm hidden-sm-down">{{props.item.player_count}}</td>
                    <td class="rollup-cell-sm hidden-sm-down">{{props.item.card_count}}</td>
                </tr>
            </template>
        </v-data-table>
    </section>
</v-flex>
</template>

<script>
  import VueSticky from 'vue-sticky';
  export default {
    name: 'WeekList',
    directives: {
      'sticky': VueSticky
    },
    data() {
      return {
        loading: false,
        weeks: null,
        error: null,
        seasons: null,
        season: null,
        stickyConfig: {
          zIndex: 1,
          stickyTop: 64,
          disabled: false
        },
        headers: [
          { text: 'Week', value: 'week', align: 'left', width: 25, sortable: false },
          { text: 'Date', value: 'week_date', align: 'left', width: 100, sortable: false },
          { text: 'Players', value: 'player_count', align: 'left', width: 75, sortable: false },
          { text: 'Cards', value: 'card_count', align: 'left', width: 75, sortable: false }
        ]
      }
    },
    methods: {
      async fetchData() {
        this.error = null;
        this.loading = true;
        try {
          // load seasons
          const seasonResult = await this.$apiClient.seasons();
          this.seasons = seasonResult.data;
          this.season = this.seasons[0];
          await this.loadWeeks();

        } catch (e) {
          this.error = e;
        }

        this.adjustOffset()

        this.loading = false;

      },
      async loadWeeks() {
        // load latest season;
        const weekResult = await this.$apiClient.weeks(this.season.season_id);
        this.weeks = weekResult.data;
      },
      adjustOffset() {
        this.stickyConfig.stickyTop = ['xs', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1 ?  48 : 64;
      },
      getEditorLink(item) {
        const routeParams = {
          seasonId: this.season.season_id,
          seasonName: this.season.name.replace(' ', '-'),
          week: item.week === 0 ? 'bye': item.week
        };

        return `/admin/rounds/${routeParams.seasonId}/${routeParams.seasonName}/${routeParams.week}`;
      }
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData',
      'season': 'loadWeeks',
      '$vuetify.breakpoint' : 'adjustOffset'
    },
    created() {
      this.fetchData();
    }
  }
</script>

<style scoped>

</style>
